/**
 * Harbour board — Needs you is a capped ranked queue, My work is claimed
 * columns. Never paginate at-risk. Never a 2,000-card kanban. Parked stays
 * off the default board. Spartacus remains the explorer.
 */

import {
  HARBOUR_COLUMN,
  HARBOUR_EMPTY_COLUMN_COPY,
  HARBOUR_EMPTY_NEEDS_YOU_COPY,
  HARBOUR_EMPTY_WORK_COPY,
  HARBOUR_NEEDS_YOU_CAP,
  HARBOUR_OWNER_FILTER,
  HARBOUR_WORK_COLUMNS,
  formatHarbourNeedsYouCaption,
  formatHarbourNeedsYouCaptionDetail,
  shouldShowHarbourNeedsYouIceberg,
  isHarbourNamelessVenueName,
} from 'src/constants/harbour'

export function capHarbourNeedsYouCards(
  cards = [],
  cap = HARBOUR_NEEDS_YOU_CAP,
) {
  return (Array.isArray(cards) ? cards : [])
    .filter(card => card?.venueId)
    .map((card, index) => ({ card, index }))
    .sort((left, right) => {
      const nameless =
        Number(isHarbourNamelessVenueName(left.card.venueName)) -
        Number(isHarbourNamelessVenueName(right.card.venueName))
      if (nameless) {
        return nameless
      }
      return left.index - right.index
    })
    .slice(0, cap)
    .map(entry => entry.card)
}

export function shouldShowHarbourMyWork(ownerFilter) {
  return ownerFilter !== HARBOUR_OWNER_FILTER.UNASSIGNED
}

/**
 * Claimed columns on the board. Parked only when Hide parked is off.
 * Unassigned is Needs you only.
 */
export function getHarbourMyWorkColumns({
  hideParked = true,
  ownerFilter = HARBOUR_OWNER_FILTER.MINE,
} = {}) {
  if (!shouldShowHarbourMyWork(ownerFilter)) {
    return []
  }
  if (hideParked) {
    return [...HARBOUR_WORK_COLUMNS]
  }
  return [...HARBOUR_WORK_COLUMNS, HARBOUR_COLUMN.PARKED]
}

export function getHarbourColumnEmptyCopy(column) {
  if (column === HARBOUR_COLUMN.WORKING) {
    return HARBOUR_EMPTY_WORK_COPY
  }
  if (column === HARBOUR_COLUMN.NEEDS_YOU) {
    return HARBOUR_EMPTY_NEEDS_YOU_COPY
  }
  return HARBOUR_EMPTY_COLUMN_COPY
}

export function getHarbourNeedsYouMeta(needsYou = {}, cards = []) {
  const shown = Math.min(
    Number(needsYou.shown != null ? needsYou.shown : cards.length) || 0,
    HARBOUR_NEEDS_YOU_CAP,
  )
  const total = Number(needsYou.total) || 0
  const cap = Number(needsYou.cap) || HARBOUR_NEEDS_YOU_CAP
  const loginGap = Number(needsYou.loginGap) || 0
  const adoptionGap = Number(needsYou.adoptionGap) || 0
  const other = Number(needsYou.other) || 0
  const iceberg = shouldShowHarbourNeedsYouIceberg({ shown, total })
  const caption =
    needsYou.caption || formatHarbourNeedsYouCaption({ shown, total })
  const detail = iceberg
    ? needsYou.detail ||
      formatHarbourNeedsYouCaptionDetail({ loginGap, adoptionGap, other })
    : null
  return { shown, total, cap, loginGap, adoptionGap, other, caption, detail }
}
